import BaseMovement from './Base'
import { calculateDistance } from '../helper'
import { animate } from '../animate'

export default class MoveTo extends BaseMovement {
    constructor(entity, time, position, options = {}) {
        super(entity, position);

        this.EntitySpeed = options.speed;
        this.UseBrownian = options.useBrownian || false;
        this.Time = time;
    }

    Play(gameSpeed) {
      
        let startPosition = {Top: this.Entity.CurrentPosition.Top, Left: this.Entity.CurrentPosition.Left};
        let topDiff = this.Position.Top - startPosition.Top;
        let leftDiff = this.Position.Left - startPosition.Left;

        let distance = calculateDistance(this.Entity.CurrentPosition, this.Position);
        let animationDuration = this.Time;
        if(this.EntitySpeed != null)
            animationDuration = distance / this.EntitySpeed * 100;

        if(distance == 0)
            return Promise.resolve();

        return animate({
            duration: gameSpeed * animationDuration,
            timing: function(t) {
                return t;
            },
            draw: function(progress) {
                let top = Number((startPosition.Top + topDiff * progress).toFixed(1));
                let left = Number((startPosition.Left + leftDiff * progress).toFixed(1));

                if(!isNaN(top) && !isNaN(left)) {
                    this.Entity.CurrentPosition.Top = top;
                    this.Entity.CurrentPosition.Left = left;

                    this.AdditionalRender(progress);
    
                    this.Entity.forceUpdate();
                }
            }.bind(this)
        }, this.cancellToken);
    }

    AdditionalRender(progress) {
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/MoveTo.js
 **/